require('./shared/layout');
import $ from 'jquery';
import Axios from 'axios';
import { parseQueryParams } from './shared/utils';
const axios = Axios.create({ withCredentials: true });

$(document).ready(function () {
  var connectId;
  var formError;
  var processing;

  var mapAppName = function (appName) {
    var mapped = appName;
    switch (appName) {
      case 'yt':
        mapped = 'youtube';
        break;
      case 'tw':
        mapped = 'twitch';
        break;
      case 'fb':
        mapped = 'facebook';
        break;
    }
    return mapped;
  };

  var setAccessToken = function (token) {};

  var initAuthShowcaseCarousel = function () {
    var carousel = $('.auth-showcase-carousel');
    if (!carousel.length) return;

    var slides = carousel.find('.auth-showcase-slide');
    var controls = carousel.find('.auth-carousel-indicators button');
    if (!slides.length) return;

    var activeIndex = 0;
    var slideIntervalMs = 4000;
    var slideTimer;

    carousel.addClass('auth-carousel-js');
    slides.eq(activeIndex).addClass('is-active');
    controls.eq(activeIndex).addClass('is-active').attr('aria-selected', 'true');

    var setSlide = function (nextIndex) {
      nextIndex = Number(nextIndex);
      if (Number.isNaN(nextIndex) || nextIndex < 0 || nextIndex >= slides.length || nextIndex === activeIndex) return;

      var currentSlide = slides.eq(activeIndex);
      var nextSlide = slides.eq(nextIndex);

      currentSlide.removeClass('is-active').addClass('is-leaving');
      nextSlide.removeClass('is-leaving');

      if (nextSlide[0]) {
        nextSlide[0].offsetHeight;
      }

      nextSlide.addClass('is-active');

      if (controls.length) {
        controls.removeClass('is-active').attr('aria-selected', 'false');
        controls.eq(nextIndex).addClass('is-active').attr('aria-selected', 'true');
      }

      activeIndex = nextIndex;

      setTimeout(function () {
        currentSlide.removeClass('is-leaving');
      }, 520);
    };

    var showNextSlide = function () {
      setSlide((activeIndex + 1) % slides.length);
    };

    var restartAutoSlide = function () {
      if (slideTimer) {
        clearInterval(slideTimer);
      }

      if (slides.length > 1) {
        slideTimer = setInterval(showNextSlide, slideIntervalMs);
      }
    };

    if (controls.length) {
      controls.on('click', function () {
        setSlide(this.dataset.slide);
        restartAutoSlide();
      });
    }

    restartAutoSlide();
  };

  var setProcessing = function (state) {
    processing = state;
    var btn = $('#form_auth .cta_wrap .cta_btn');
    if (processing === true) {
      btn.addClass('processing');
    } else {
      btn.removeClass('processing');
    }

    btn.attr('disabled', processing);
  };

  var setFormError = function (err) {
    $('.spinner-wrap').hide();
    $('body').addClass('errored');
    let msg = (err && err.message) || (typeof err === 'string' ? err : '');
    $('body').toggleClass('has-form-error', Boolean(msg));
    $('#form_error').text(msg);
  };

  var setAuthFormError = function (err) {
    formError = err;
    var el = $('#auth_form_error');
    if (err === null) {
      el.text('');
      el.hide();
      $('body').removeClass('has-auth-form-error');
    } else {
      let msg = (err && err.message) || (typeof err === 'string' ? err : '');
      el.text(msg);
      el.toggle(Boolean(msg));
      $('body').addClass('errored').toggleClass('has-auth-form-error', Boolean(msg));
    }
  };

  var onSignupCheckpoint = function (body) {
    $('#when-signup').addClass('active');
    connectId = body.connectId;

    var user = body.candidate;
    if (user) {
      Object.keys(user).forEach((prop) => {
        if (prop === 'avatar') {
          $(`.oauth-user-${prop}`).attr('src', user[prop]);
        } else {
          $(`.oauth-user-${prop}`).text(user[prop]);
        }
      });
    }
  };

  var onSignedin = function () {
    var searchParams = parseQueryParams(window.location.search || '');
    var redirecUri = searchParams.redirect;
    if (!redirecUri) {
      // check of any passed state params
      if (searchParams.state) {
        var originSearchStr;
        try {
          originSearchStr = atob(searchParams.state);
        } catch (e) {}

        if (originSearchStr) {
          var originSearchParams = parseQueryParams(originSearchStr);
          if (originSearchParams.redirect) {
            redirecUri = originSearchParams.redirect;
          }
        }
      }
    }

    if (redirecUri) {
      redirecUri = decodeURI(redirecUri);
    } else {
      redirecUri = process.env.LOGIN_REDIRECT_URL;
    }

    window.location.href = redirecUri;
  };

  var onSiginFailed = function (err) {
    setFormError(err);
  };

  var onSigupFailed = function (e) {
    var err = e && e.response && e.response.data;
    setAuthFormError(err);
    setProcessing(false);
  };

  var signinWithConnectCode = function (appName, code) {
    var params = '?code=' + code + '&appName=' + appName;
    var apiUri = process.env.AUTH_API_BASE + '/auth/signin/connect';
    axios
      .post(apiUri + params, undefined)
      .then((res) => {
        console.log('connect-login-res', res.data);
        const body = res.data || {};
        // on checkpoint required
        if (body.checkpoint) {
          onSignupCheckpoint(body);
        } else {
          onSignedin();
        }
      })
      .catch((e) => {
        var err = e && e.response && e.response.data;
        onSiginFailed(err);
      });
  };

  var signupWithConnectId = function (payload) {
    var apiUri = process.env.AUTH_API_BASE + '/auth/signup/connect';
    axios.post(apiUri, payload).then(onSignedin).catch(onSigupFailed);
  };

  var onSignupFormSubmit = function (ev) {
    ev.preventDefault();
    if (processing) return;

    var promosConsent = $('#promosConsent');
    var payload = {
      connectId,
      promosConsent: promosConsent.prop('checked'),
    };

    setAuthFormError(null);
    setProcessing(true);

    setTimeout(() => {
      signupWithConnectId(payload);
    }, 1000);
  };

  // check data from query params
  var searchParams = parseQueryParams(window.location.search || '');
  if (searchParams.appName) {
    $('.spinner').addClass(searchParams.appName);
    var appName = mapAppName(searchParams.appName);
    $('.oauth-appName').text(appName);
    $('.oauth-appAvatar').addClass(appName);
  }

  if (searchParams.appName && searchParams.code) {
    signinWithConnectCode(searchParams.appName, searchParams.code);
  } else if (searchParams.error) {
    var err = {
      message: decodeURIComponent(
        searchParams.error_description || searchParams.error || '',
      ).replace(/\-|\+/g, ' '),
    };
    setFormError(err);
  } else {
    setFormError(null);
  }

  $('#form_auth').submit(onSignupFormSubmit);
  initAuthShowcaseCarousel();
});
